import { Component, Input } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { ResultEditPreroundKoPage } from '../../edits/pre-round-ko/preround-edit-ko';

@Component({
  selector: 'result-pre-round-ko',
  templateUrl: 'result-pre-round-ko.html',
})
export class ResultPreRoundKoPage {
  gamePlanList: IGamePlan[] = [];
  tab: string = 'overview';
  roundPhaseBtn = false;

  /**
   * @todo: big refactoring [ plan -> activePlan]
   */
  @Input() plan: any;
  @Input() activePlan: any;
  @Input() header: boolean = true;

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private gs: TournamentService,
    private toastCtrl: ToastController
  ) { 
      this.createEmptyGraph();
  }

  ionViewDidLoad(){
    this.plan = this.navParams.get('plan') || this.plan;
  }

  onEditTeam(teamIndex: any){
    if(teamIndex.graph && !this.plan.roundPhase){
      this.message();
      return;
    }

    let modal = this.modalCtrl.create(ResultEditPreroundKoPage, { plan: this.plan, teamIndex: teamIndex, roundPhase: this.plan.roundPhase});
    modal.present();
    modal.onDidDismiss(() => {
      if(!this.plan.roundPhase) this.isRoundPhaseReady();
      this.sortTeams();
      // if(this.plan.roundPhase){
      //   this.createRoundGameTable();
      // }
    });
  }

  message(){
    this.toastCtrl.create({
      message: 'All teams should play',
      duration: 3000
    });
  }

  isRoundPhaseReady(){
    let check = false;
    for(let r = 0; r < this.plan.round; r++){
      for(let i = 0; i < this.plan.gameTable[r].length; i++){
        for(let j = 0; j < this.plan.gameTable[r][i].length; j++){
            if(!this.plan.gameTable[r][i][j].played){
              check = true;
            }
        }
      }
    }
    this.roundPhaseBtn = !check;
  }

  onRoundPhaseStart(){
    this.plan.roundPhase = true;
    this.roundPhaseBtn = false;
    this.createRoundGameTable();
    this.tab = 'map';

  }

  createRoundGameTable(){
    // this.updateTeams();
    this.sortTeams();
    this.transform();
    this.gs.save();
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => {
      this.gs.planList[this.activePlan] = plan;
    })
  }


  createEmptyGraph(){
    setTimeout(() => {
      if(this.plan.roundGameTable.length  > 0) return; 

      let n = Number(this.plan.teamNum);
      let id = 0;
      this.matchRecursive(n);
      for(let i = 0; i < this.rounds.length; i++){
        let sum = 0;
        let pre = 0;
        let arr = [];
        for(let j = 0; j < this.rounds[i]; j += 2){
          pre = this.rounds[i] * i;
          let gamePlan = {
            id: id,
            type: this.plan.type,
            gameDay: i,
            name: this.plan.name,
            winner: -1,
            team1: {
              result: 0,
              points: 0,
              id:  -1,
              name: "" 
            },
            team2: {
              result: 0,
              points: 0,
              id:  -1,
              name:  ""
            }
          }
          arr.push(gamePlan);
          id += 1;
        }
        this.plan.roundGameTable.push(arr);
        sum += pre;
      }
    }, 500);
  }

  matchRecursive(n: number): number{
    if(n <= 1){
      return this.rounds.length;
    }else{
      this.rounds.push(n);
      return this.matchRecursive(n / 2);
    }
  }

  transform(){
    this.plan.roundGameTable[0] = this.matchAlgorithm();
  }

  rounds = [];
  matchAlgorithm(){
    // the first day - start
    let N = Number(this.plan.groupNum);
    let id = 0;
    let arr = [];
    for(let i = 0; i < N-1; i++){
      let add = [];
      for(let j = 0; j < this.plan.roundTeams[i].length- 1; j+=2){
       let gamePlan = {
          id: id,
          type: this.plan.type,
          gameDay: 0,
          name: this.plan.name,
          winner: -1,
          played: false,
          team1: {
            result: 0,
            points: 0,
            id: this.plan.roundTeams[i][j+1].id,
            name: this.plan.roundTeams [i][j+1].name
          },
          team2: {
            result: 0,
            points: 0,
            id: this.plan.roundTeams[i+1][j].id,
            name: this.plan.roundTeams[i+1][j].name
          }
        }

        arr.push(gamePlan);

        if(i == 0){
          let addGamePlan = {
            id: id,
            type: this.plan.type,
            gameDay: 0,
            name: this.plan.name,
            winner: -1,
            played: false,
            team1: {
              result: 0,
              points: 0,
              id: this.plan.roundTeams[i][j].id,
              name: this.plan.roundTeams [i][j].name
            },
            team2: {
              result: 0,
              points: 0,
              id: this.plan.roundTeams[N-1][j+1].id,
              name: this.plan.roundTeams[N-1][j+1].name
            }
          };
          add.push(addGamePlan);
          if(j + 1 >= this.plan.roundTeams[i].length - 1){
            for(let k = 0; k < add.length; k++){
              arr.push(add[k]);
            }
          }
        }
        id += 1;
      }
    }

    return arr;
  }

  sortTeams(){
    for(let i = 0; i < this.plan.roundTeams.length; i++){
     this.plan.roundTeams[i].sort((a, b) => b.points - a.points);
    }
  }

}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-pre-round-ko/result-pre-round-ko.ts